import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MQTTState {
  isConnected: boolean;
  isConnecting: boolean;
  connectionError: string | null;
  userId: string | null;
  clientId: string | null;
  subscriptions: string[];
  lastMessage: {
    topic: string;
    data: any;
    timestamp: number;
  } | null;
}

const initialState: MQTTState = {
  isConnected: false,
  isConnecting: false,
  connectionError: null,
  userId: null,
  clientId: null,
  subscriptions: [],
  lastMessage: null,
};

const mqttSlice = createSlice({
  name: 'mqtt',
  initialState,
  reducers: {
    startConnecting: (state, action: PayloadAction<{ userId: string; clientId: string }>) => {
      state.isConnecting = true;
      state.connectionError = null;
      state.userId = action.payload.userId;
      state.clientId = action.payload.clientId;
    },
    connectionSuccess: (state) => {
      state.isConnected = true;
      state.isConnecting = false;
      state.connectionError = null;
    },
    connectionFailure: (state, action: PayloadAction<string>) => {
      state.isConnected = false;
      state.isConnecting = false;
      state.connectionError = action.payload;
    },
    disconnect: (state) => {
      state.isConnected = false;
      state.isConnecting = false;
      state.connectionError = null;
      state.userId = null;
      state.clientId = null;
      state.subscriptions = [];
      state.lastMessage = null;
    },
    updateSubscriptions: (state, action: PayloadAction<string[]>) => {
      state.subscriptions = action.payload;
    },
    receiveMessage: (state, action: PayloadAction<{ topic: string; data: any }>) => {
      state.lastMessage = {
        topic: action.payload.topic,
        data: action.payload.data,
        timestamp: Date.now(),
      };
    },
    clearError: (state) => {
      state.connectionError = null;
    },
  },
});

export const {
  startConnecting,
  connectionSuccess,
  connectionFailure,
  disconnect,
  updateSubscriptions,
  receiveMessage,
  clearError,
} = mqttSlice.actions;

export default mqttSlice.reducer; 